import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'sc-view-wrapper-content',
  templateUrl: './sc-view-wrapper-content.component.html',
  styleUrls: ['./sc-view-wrapper-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScViewWrapperContentComponent implements OnInit {
  @Input() actions: any[];
  @Input() total: number;
  @Input() title: string;
  @Input() key: string;
  @Input() showAddButton: boolean;
  @Input() disabledAddButton: boolean;
  @Output() selectedViewChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() addChange: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}

  openDialog() {
    this.addChange.emit();
  }
}
